import { css } from '@emotion/css';

export const scorecardSelectorStyles = css`
  .preview-btn {
    opacity: 0;
    :hover {
      background-color: var(--bg-primary) !important;
    }
  }
  :hover {
    .preview-btn {
      opacity: 1;
    }
  }
`;
